export default __webpack_public_path__ + "static/media/iikvideo.44200bbe.mp4";